import React, { useState, useEffect } from 'react';
import { HelpCircle } from 'lucide-react';
import TourEngine from './TourEngine';

const API = process.env.REACT_APP_BACKEND_URL;

const PageTourButton = ({ pageView }) => {
  const [tour, setTour] = useState(null);
  const [showTour, setShowTour] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!pageView || !token) return;
    fetch(`${API}/api/tours/page/${pageView}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(data => { if (data.tour) setTour(data.tour); })
      .catch(() => {});
  }, [pageView, token]);

  if (!tour) return null;

  return (
    <>
      {/* Inline button for desktop */}
      <button
        onClick={(e) => { e.stopPropagation(); setShowTour(true); }}
        className="hidden sm:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium bg-amber-100 text-amber-700 hover:bg-amber-200 transition-colors flex-shrink-0"
        data-testid="page-tour-button"
        title={`Tour: ${tour.name}`}
      >
        <HelpCircle className="h-3.5 w-3.5" /> Tour
      </button>

      {/* Floating pill button for mobile — always visible bottom-left */}
      <button
        onClick={(e) => { e.stopPropagation(); setShowTour(true); }}
        className="sm:hidden fixed bottom-20 left-4 z-40 inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-xs font-semibold bg-amber-500 text-white shadow-lg hover:bg-amber-600 transition-all"
        data-testid="page-tour-button-mobile"
      >
        <HelpCircle className="h-4 w-4" /> Tour
      </button>

      {showTour && (
        <TourEngine
          tour={tour}
          onComplete={() => setShowTour(false)}
          onSkip={() => setShowTour(false)}
        />
      )}
    </>
  );
};

export default PageTourButton;
